package org.matthewo.recharts.collection

import kotlin.math.max
import kotlin.math.min

fun Iterable<Double>.rangeOrNull(): ClosedFloatingPointRange<Double>? {
    var min = Double.MAX_VALUE
    // the lowest double; Double.MIN_VALUE is the smallest positive one and would beat any negative value
    var max = -Double.MAX_VALUE
    var empty = true
    for (element in this) {
        if (element.isNaN()) return null
        min = min(min, element)
        max = max(max, element)
        empty = false
    }
    if (empty) return null
    return min..max
}

fun <T> Iterable<T>.rangeByOrNull(selector: (T) -> Double): ClosedFloatingPointRange<Double>? {
    var min = Double.MAX_VALUE
    // the lowest double; Double.MIN_VALUE is the smallest positive one and would beat any negative value
    var max = -Double.MAX_VALUE
    var empty = true
    for (element in this) {
        val value = selector(element)
        if (value.isNaN()) return null
        min = min(min, value)
        max = max(max, value)
        empty = false
    }
    if (empty) return null
    return min..max
}
